<template>
  <div class="container">
    <home-title
      title="学习路径"
      link2="/learn/myPath"
      :icon="require('@/assets/images/home/home_title/icon4.svg')"
    ></home-title>
    <div class="study_path_box">
      <div
        class="study_item ta3"
        v-for="e in pathList"
        :key="e.zt_con_id"
        @click="goPath(e.zt_con_id)"
      >
        <div class="left">
          <div
            class="left_img"
            :style="`background:url(${$homeSrc(e.zt_con_pic)}) no-repeat;`"
          ></div>
          <!-- <img :src="$homeSrc(e.zt_con_pic)" alt="" /> -->
        </div>
        <div class="right">
          <p class="title toh">{{ e.zt_con_name }}</p>
          <div class="introduce toh3">
            {{ e.zt_con_intro }}
          </div>
          <div class="tag">
            <span>适用学员：</span>
            <div
              class="tag_item"
              v-for="(item, i) in e.zt_con_stus.indexOf('，') != -1
                ? e.zt_con_stus.split('，')
                : e.zt_con_stus.split(',')"
              :key="i"
            >
              {{ item }}
            </div>
          </div>
          <!-- <div class="people_num dfAic">
            <img src="@/assets/images/home/item_icon3.svg" alt="" />
            在学人数：
            <span>186.9万</span>
          </div> -->
        </div>
      </div>
    </div>
    <div class="cut ta3" @click="getList()">
      换一批 <i class="el-icon-refresh ta3"></i>
    </div>
  </div>
</template>

<script>
import homeTitle from "./components/homeTitle";
import { getIndexLearnpath } from "@/api/home";
export default {
  name: "studyPath",
  components: { homeTitle },
  data() {
    return {
      page: 1,
      pathList: [],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      getIndexLearnpath({ page: this.page }).then((res) => {
        this.page++;
        this.pathList = res.data.data;
        if (this.pathList.length < 4) {
          if (this.pathList.length) {
            this.page = 1;
          } else {
            this.page = 1;
            this.getList();
          }
        }
      });
    },
    goPath(id) {
      location.href = `https://lib.yiihuu.com/path_intro/?id=${id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 50px 0;
  .study_path_box {
    width: 100%;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    .study_item {
      width: 630px;
      height: 240px;
      margin-left: 48px;
      background: linear-gradient(
        92deg,
        rgba(255, 255, 255, 0) 0%,
        #ffffff 100%
      );
      border-radius: 10px;
      display: flex;
      justify-content: space-between;
      padding: 13px 20px 0 0;
      margin-bottom: 30px;
      cursor: pointer;
      position: relative;
      .left {
        margin-left: -48px;
        position: relative;
        .left_img {
          width: 357px;
          height: 200px;
          border-radius: 10px;
          background-size: cover !important;
          background-position: center center !important;
          -webkit-transform: rotate(0.001deg) translateZ(0);
        }
        &::after {
          content: "";
          width: 100%;
          height: 14px;
          background: url("@/assets/images/home/img_shadow.png") no-repeat;
          position: absolute;
          bottom: 13px;
          left: 7px;
        }
      }
      .right {
        width: 281px;
        position: relative;
        margin-bottom: 20px;
        .title {
          font-size: 16px;
          font-weight: 600;
          line-height: 21px;
          color: #333333;
          letter-spacing: 1px;
          margin-top: 7px;
        }
        .introduce {
          font-size: 12px;
          line-height: 16px;
          color: #8a8a8a;
          margin-top: 12px;
          height: 48px;
        }
        .tag {
          margin-top: 12px;
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          font-size: 12px;
          line-height: 16px;
          color: #666666;
          span {
            margin-bottom: 8px;
          }
          .tag_item {
            margin: 0 6px 8px 0;
            background: #eff5f4;
            border-radius: 12px;
            padding: 4px 10px;
            color: #79bfb4;
          }
        }
        .people_num {
          position: absolute;
          left: 0;
          bottom: 0;
          font-size: 12px;
          line-height: 16px;
          color: #999;

          img {
            width: 16px;
            height: 16px;
            margin-right: 4px;
          }
          span {
            color: #22b69e;
          }
        }
      }
      &::before {
        content: "";
        display: inline-block;
        position: absolute;
        width: 357px;
        height: 200px;
        background: rgba(51, 51, 51, 0.24);
        border-radius: 10px;
        top: 13px;
        left: -48px;
        opacity: 0;
        transition: 0.3s;
        z-index: 2;
      }

      &:hover {
        -moz-transform: translateY(-10px);
        -webkit-transform: translateY(-10px);
        -o-transform: translateY(-10px);
        -ms-transform: translateY(-10px);
        transform: translateY(-10px);
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.16);
        &::before {
          opacity: 1;
        }
      }
    }
  }
  .cut {
    width: 150px;
    height: 36px;
    text-align: center;
    line-height: 36px;
    background: rgba(255, 255, 255, 0.39);
    border: 1px solid #ddd;
    border-radius: 100px;
    font-size: 14px;
    color: #999;
    margin: 0 auto;
    cursor: pointer;
    i {
      transform: rotateY(180deg);
    }
    &:hover {
      border: 1px solid #22b79e;
      color: #22b79e;
      i {
        transform: rotateX(-180deg);
      }
    }
  }
}

@media screen and (max-width: 1500px) and (min-width: 270px) {
  .container {
    .study_path_box {
      .study_item {
        width: 498px;
        height: 190px;
        margin-left: 38px;
        padding: 10px 8px 0 0;
        &::before {
          width: 282px;
          height: 158px;
          top: 10px;
          left: -38px;
        }
        .left {
          margin-left: -38px;
          .left_img {
            width: 282px;
            height: 158px;
          }
          &::after {
            width: 270px;
            bottom: 8px;
            background-size: 100% 100%;
            left: 6px;
          }
        }
        .right {
          width: 230px;
          .introduce {
            margin-top: 4px;
          }
          .tag {
            margin-top: 4px;
            span {
              margin-bottom: 4px;
            }
            .tag_item {
              margin-bottom: 4px;
            }
          }
        }
      }
    }
  }
}
</style>
